import React, {useEffect, useState} from 'react';
import LeftPane from "./components/LeftPane";
import RightPane from "./components/RightPane";
import {BrowserRouter} from "react-router-dom";
import setConfig from './config/auth';
import {
   getCurrentUser
} from 'aws-amplify/auth';

import { Amplify } from 'aws-amplify';
import { decodeJWT } from 'aws-amplify/auth';
import { useCookies } from 'react-cookie';
import NotAuthenticated from "./components/NotAuthenticated";


function App() {

    const [cookies, setCookie, removeCookie] = useCookies(['accessToken', 'idToken']);
    const [user, setUser] = useState(null);
    let config = setConfig(null);

    const myTokenProvider = {
        async getTokens({ forceRefresh } = {}) {
            if (forceRefresh) {
                // try to obtain new tokens if possible
            }
            let accessToken = cookies.accessToken;
            let idToken = cookies.idToken;

            if (cookies.accessToken == null) {
                console.log("Cookie is null");
                accessToken = getAccessTokenFromUrl();
                setCookie('accessToken', accessToken, {secure: true});
            }
            if (cookies.idToken == null) {
                idToken = getIdTokenFromUrl();
                setCookie('idToken', idToken, {secure: true});
            }

            return {
                accessToken: decodeJWT(accessToken),
                idToken: decodeJWT(idToken),
            };
        },
    };

    const getAccessTokenFromUrl = () => {
        const url = new URL(window.location.href);
        const match = url.hash.match(/access_token=([^&]*)/);
        return match ? match[1] : null;

    };

    const getIdTokenFromUrl = () => {
        const url = new URL(window.location.href);
        const match = url.hash.match(/id_token=([^&]*)/);
        return match ? match[1] : null;

    };


    const getClientFromAccessTokenAndSetConfig = async(accessTokenString) => {
        const accessDetails = decodeJWT(accessTokenString);
        return setConfig(accessDetails.payload.client_id);

    }

    const checkTokenExpiry = (idTokenString) => {
        const idDetails = decodeJWT(idTokenString);
        if (idDetails.payload.exp < Date.now() / 1000) {
            removeCookie('accessToken', {secure: true});
            removeCookie('idToken', {secure: true});
            window.location = '/';
        }

    }

    const checkUrl = () => {
        const url = new URL(window.location.href);
        if (url.hash.includes('id_token')) {
            const baseUrl = window.location.origin + window.location.pathname;
            window.history.replaceState({}, document.title, baseUrl);
        }

    }



    const getCurrentCognitoUser = async () => {
        await Amplify.configure(config, {
            Auth: {
                tokenProvider: myTokenProvider
            }
        });

        try {
            const { username, userId, signInDetails } = await getCurrentUser();

            return username;
        } catch (error) {
            console.error("Error fetching current Cognito user:", error);
            throw error;
        }
    };

    useEffect(() => {

        const checkLoginStatus = async () => {
            if (cookies.accessToken == null) {
                const accessTokenString = getAccessTokenFromUrl();
                const idTokenString = getIdTokenFromUrl();

                if (accessTokenString != null) {
                    setCookie('accessToken', accessTokenString, {secure: true});
                    setCookie('idToken', idTokenString, {secure: true});
                    console.log("Setting cookies");
                    config = await getClientFromAccessTokenAndSetConfig(accessTokenString);

                }
            } else {

                config = await getClientFromAccessTokenAndSetConfig(cookies.accessToken);
                console.log("Cookie found");
                checkTokenExpiry(cookies.idToken);

            }

            getCurrentCognitoUser().then(setUser).catch(console.error);

        };
        checkLoginStatus().then(checkUrl);

    }, []);

    if (user == null) {
        const redirectUrl = process.env.REACT_APP_REDIRECT_SIGN_IN;
        return (
            <BrowserRouter>
            <div className="App"
                 style={{fontFamily: 'Inter', width: 1000, display: 'flex', height: '100vh', margin: 0}}>
                <NotAuthenticated redirectUrl={redirectUrl}/>
            </div>
            </BrowserRouter>);
    } else {

        const idInfo = decodeJWT(cookies.idToken);
        const initials = idInfo.payload.given_name.charAt(0) + idInfo.payload.family_name.charAt(0);
        return (<BrowserRouter>
            <div className="App"
                 style={{fontFamily: 'Inter', width: 1440, display: 'flex', height: '100vh', margin: 0}}>
                <LeftPane initials={initials}/>
                <RightPane/>
            </div>
        </BrowserRouter>);
    }
}

export default App;
